import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
  listItemIcon: {
    minWidth: 36,
  },
}));
